import { Faq as FaqType } from 'libs/http/api/content/content.types';

export const FAQ_DATA: FaqType[] = [
  {
    id: 'what-is',
    question: 'What is B2B data enrichment?',
    answer:
      'B2B data enrichment is the process of appending missing or outdated fields to your company and executive records — legal names, registration numbers, addresses, industry codes, financials and officers. Global Database enriches records with primary data sourced from 400+ government registries, so every appended field traces back to an official filing.',
    default_opened: true,
  },
  {
    id: 'how-it-works',
    question: 'How does company data enrichment work?',
    answer:
      'You send an identifier — a company name, domain, VAT number, registration number or LinkedIn URL. Our matching engine resolves it against official registry records, assigns a match confidence grade, and returns the full company profile with every field cited to its source registry.',
  },
  {
    id: 'fields',
    question: 'What data fields can be appended to my records?',
    answer:
      'Up to 40 fields per record, including legal and trading names, registration and VAT numbers, company status, registered addresses, industry codes (SIC, NACE, NAICS), employee counts, filed revenue and financials, directors, shareholders, UBOs and corporate hierarchy.',
  },
  {
    id: 'identifiers',
    question: 'What identifiers can I match my data by?',
    answer:
      'Company name, website, VAT number, registration number, LinkedIn Company URL or LinkedIn Person URL — the tool matches both companies and executives. For name, VAT, registration number and website matching, a country field is required to guarantee precision.',
  },
  {
    id: 'why-registry',
    question: 'What makes government registry data different from other enrichment sources?',
    answer:
      'Registry data is primary-source: it comes from the official filings companies legally submit to their national registries. Every field we append carries its registry source and filing reference, so your data, compliance and audit teams can verify any value against the government record it came from.',
  },
  {
    id: 'accuracy',
    question: 'How accurate is the matching?',
    answer:
      'Every match receives a confidence grade: A for an exact match against the registry record, B for a strong match with minor discrepancies, and C for a partial match flagged for review. You choose which grades to accept before downloading or syncing the enriched data.',
  },
  {
    id: 'crm',
    question: 'Can I enrich Salesforce or HubSpot directly?',
    answer:
      'Yes. Native connectors match your CRM accounts to registry records, append the missing fields, and keep them refreshed automatically as registries publish updates — no exports or re-imports.',
  },
  {
    id: 'coverage',
    question: 'Which countries does the enrichment cover?',
    answer:
      'Coverage spans 600M+ companies across 200+ countries and territories, sourced from 400+ government registries — including markets where most enrichment providers have little or no depth.',
  },
  {
    id: 'freshness',
    question: 'How is the enriched data kept up to date?',
    answer:
      'Records are refreshed in line with official registry publication and synced on your schedule. When a company files a change — new officers, a status change, updated accounts — the corresponding fields update in your systems.',
  },
  {
    id: 'kyb',
    question: 'Is registry-based enrichment suitable for KYB and compliance workflows?',
    answer:
      'Yes. Because every field is sourced from official government filings with full source attribution, enriched records can support KYB verification, onboarding and audit workflows. Data is drawn from public official registries; your compliance team defines the lawful basis and controls for your specific use case.',
  },
];
